import { Injectable } from '@angular/core';

@Injectable()
export class AcessibilidadeService {

  atualizarTamanhoFonte(tamanhoFonte) {
    const htmlRoot: HTMLElement = document.getElementsByTagName('html')[0];
    if (htmlRoot != null) {
      htmlRoot.style.fontSize = `${tamanhoFonte}px`;
    }
  }

  classesTamanhoFonte(tamanhoFonte) {
    switch (tamanhoFonte) {
      case 20: {
        document.querySelector('body').classList.add('aumenta-fonte', 'fonte-base-20');
        document.querySelector('body').classList.remove('fonte-base-24');
        break;
      }
      case 24: {
        document.querySelector('body').classList.add('aumenta-fonte', 'fonte-base-24');
        document.querySelector('body').classList.remove('fonte-base-20');
        break;
      }
      default: {
        document.querySelector('body').classList.remove('aumenta-fonte', 'fonte-base-20', 'fonte-base-24');
        break;
      }
    }
  }

}
